const accentColors = {
  ACCENT_20: '#FFF5F4',
  ACCENT_50: '#FDE9E7',
  ACCENT_100: '#FFCCBD',
  ACCENT_200: '#FFAA92',
  ACCENT_300: '#FF8867',
  ACCENT_400: '#FF6C45',
  ACCENT_500: '#FF5025',
  ACCENT_600: '#FF4821',
  ACCENT_700: '#F1421C',
  ACCENT_800: '#E33B17',
  ACCENT_900: '#CA2C0D',
}

export default accentColors
